import React, { useContext } from 'react';
import AppContainer from 'containers/AppContainer';
import Header from 'components/Header';
import Content from 'components/Content';
import Footer from 'components/Footer';
import Button from 'components/Button';
import MessageWithGif from 'components/MessageWithGif';
import { useNavigate } from 'react-router';
import { LocaleContext } from 'containers/LocaleContext';
import { useStore } from 'hooks/useStore';
import { useGetLocations } from '../queries/useLocationQueries';
import { format } from 'date-fns';
export function ReceiptNotFound() {
    const { I18n } = useContext(LocaleContext);
    const navigate = useNavigate();
    const country = useStore((s) => { var _a; return (_a = s.country) !== null && _a !== void 0 ? _a : 'Unknown'; });
    const locationId = useStore((s) => { var _a, _b; return (_b = (_a = s.formData) === null || _a === void 0 ? void 0 : _a.locationId) !== null && _b !== void 0 ? _b : 'Unknown'; });
    const date = useStore((s) => { var _a, _b; return format(((_a = s.formData) === null || _a === void 0 ? void 0 : _a.date) ? new Date((_b = s.formData) === null || _b === void 0 ? void 0 : _b.date) : Date.now(), 'yyyy-MM-dd'); });
    const amount = useStore((s) => { var _a, _b; return (_b = (_a = s.formData) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 'Unknown'; });
    const { data: station } = useGetLocations({
        options: {
            select: (data) => { var _a; return (_a = data.find((location) => location.id === locationId)) === null || _a === void 0 ? void 0 : _a.name; },
        },
    });
    const handleSubmit = () => {
        navigate('../');
    };
    const NotFoundTextWithEmailLink = () => {
        const recipient = I18n.t('receipt_found_email.recipient');
        const subject = I18n.t('receipt_found_email.subject');
        const body = I18n.t('receipt_found_email.body_1') +
            '%0D%0D%0A' +
            I18n.t('receipt_found_email.body_2') +
            '%0D%0D%0A' +
            I18n.t('receipt_found_email.body_3') +
            '%0D%0D%0A' +
            I18n.t('receipt_found_email.body_4') +
            '%0D%0D%0A' +
            I18n.t('receipt_found_email.session_country', { country }) +
            '%0D%0D%0A' +
            I18n.t('receipt_found_email.fastned_station', { station }) +
            '%0D%0D%0A' +
            I18n.t('receipt_found_email.session_date', { date }) +
            '%0D%0D%0A' +
            I18n.t('receipt_found_email.exact_amount', { amount }) +
            '%0D%0D%0A';
        return (React.createElement(React.Fragment, null,
            I18n.t('receipt_not_found.text') + ' ',
            React.createElement("a", { className: "blue", href: `mailto:${recipient}?&subject=${subject}&body=${body}` }, I18n.t('receipt_not_found.link_text'))));
    };
    return (React.createElement(AppContainer, null,
        React.createElement(Header, null),
        React.createElement(Content.Wrapper, null,
            React.createElement(Content.Base, { padded: true },
                React.createElement(MessageWithGif, { title: I18n.t('receipt_not_found.title'), text: NotFoundTextWithEmailLink(), gifUrl: require('../assets/gifs/receipt_not_found.gif') }))),
        React.createElement(Footer, null,
            React.createElement(Button, { onClick: handleSubmit }, I18n.t('buttons.try_again')))));
}
